module.exports = __webpack_public_path__ + "img/btn_menu_nzz_c.669dc816.png";